import { render, staticRenderFns } from "./Invoice.vue?vue&type=template&id=510b332a&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=js"
export * from "./Invoice.vue?vue&type=script&lang=js"
import style0 from "./Invoice.vue?vue&type=style&index=0&id=510b332a&prod&scoped=true&lang=css"
import style1 from "./Invoice.vue?vue&type=style&index=1&id=510b332a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b332a",
  null
  
)

export default component.exports